import $ from 'jquery';

export default {
  formClass: '.litter-quiz-form',
  $formElement: null,

  init() {
    const name = $('#input_40_1').val();
    const avatar = $('#input_40_3 input[name="input_3"]:checked').val();

    if ( $(this.formClass).length ) {
      $(window).scrollTop(0);
      this.$formElement = $(this.formClass);

      if ( name ) {
        this.replace_your_cat_with(name);
      }

      if ( avatar ) {
        this.insert_avatar(avatar);
      }
    }
  },

  replace_your_cat_with(name) {

    this.$formElement.find('.gfield_label').each( function() {
      $(this).find('.gfield_required').remove();
      let text = $(this).text();
      text = text.replace("your cat", name);
      $(this).text(text);
    });

    this.$formElement.find('.your-cat').each( function() {
      $(this).text(name);
    });
  },

  insert_avatar(avatar) {
    $('.insert-cat-avatar').each( function() {
      // SHAME... tried cloning the img tag from the radio label, wasn't able
      $(this).append(`<img src="/wp-content/themes/drelseys/dist/img/cat-avatars/${avatar}.png" alt="" onerror="this.style.display='none'" class="litter-quiz-cat-avatar">`);
    });
  },
}
